const unpackLzw = (codes: number[]): string | null => {
    if (codes.length === 0 || !Number.isInteger(codes[0]) || codes[0] < 0 || codes[0] > 255) {
        return null;
    }
    const dict: string[] = [];
    for (let i = 0; i < 256; i++) {
        dict[i] = String.fromCharCode(i);
    }
    let next = 256;
    let prev = dict[codes[0]];
    let result = prev;
    for (let i = 1; i < codes.length; i++) {
        const code = codes[i];
        let entry: string;
        if (dict[code] !== undefined) {
            entry = dict[code];
        } else if (code === next) {
            entry = prev + prev.charAt(0);
        } else {
            return null;
        }
        result += entry;
        dict[next++] = prev + entry.charAt(0);
        prev = entry;
    }
    return result;
};

/**
 * Articulate-Rise-Pakete melden im SCORM-Modus nie cmi.progress_measure;
 * der Kursfortschritt steckt ausschließlich LZW-komprimiert in
 * cmi.suspend_data als {"v":<n>,"d":[<LZW-Codes>]}. Dekodiert ergibt das
 * {"progress":{"p":<Kurs-%>,"lessons":{...}}}, wobei progress.p erst
 * erscheint, sobald mindestens eine Lektion abgeschlossen ist — identisch
 * zur "x% FERTIG"-Anzeige im Paket selbst. Liefert null für alles, was
 * nicht diesem Format entspricht (fremde SCORM-Pakete bleiben unberührt).
 */
export const extractRiseCourseProgress = (rawSuspendData: string): number | null => {
    try {
        const envelope = JSON.parse(rawSuspendData);
        if (!envelope || !Array.isArray(envelope.d)) {
            return null;
        }
        const json = unpackLzw(envelope.d);
        if (json === null) {
            return null;
        }
        const p = JSON.parse(json)?.progress?.p;
        if (typeof p !== 'number' || !isFinite(p)) {
            return null;
        }
        return Math.round(Math.min(100, Math.max(0, p)));
    } catch {
        return null;
    }
};
